import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const MultiLineCellRenderer = ({ value }) => (
  <div>
    { // eslint-disable-next-line
      value != null ? value.split('\n').map((item, index) => item != null && <span key={ index }>{ item }<br /></span>) : 'N/A'
    }
  </div>
);

MultiLineCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

MultiLineCellRenderer.defaultProps = {
  value: 'N/A'
};
